/**
 * Leaf module for site-wide identifiers. Kept free of imports so both the
 * schema layer (src/lib/seo.ts) and the data layer (src/data/pricing.ts,
 * src/data/tiers.ts) can depend on it without a circular import.
 */

export const SITE_URL = "https://ajility.com.au";

export const absoluteUrl = (path: string) =>
  path === "/" || path === "" ? `${SITE_URL}/` : `${SITE_URL}${path}`;

export const ORG_ID = `${SITE_URL}/#organization`;
export const SITE_ID = `${SITE_URL}/#website`;
export const ADAM_ID = `${SITE_URL}/#person-adam`;
export const LOGO_ID = `${SITE_URL}/#logo`;
